import { render } from "./InformationIcon.vue?vue&type=template&id=7052c630"
import script from "./InformationIcon.vue?vue&type=script&lang=js"
export * from "./InformationIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__